/**
 * AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPage
 */

import { useAlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageLogic } from '@/hooks/traits/useAlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageLogic';
import type { AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageConfig } from '@/hooks/traits/useAlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostView as AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostViewEntity } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostView } from '@/components/traits/AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostView';
import { Box } from '@almadar/ui/components';
import { AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostFooterView } from '@/components/traits/AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostFooterView';
import { Container } from '@almadar/ui/components';
import { AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostHeaderView } from '@/components/traits/AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostHeaderView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageViewProps {
  config?: Partial<AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageConfig>;
}

export function AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageView({ config: propsConfig }: AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostWhatIfSoftwareCouldBuildItselfSL" trait="AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box paddingY="xl" bg="transparent" fullWidth={true}><Container maxWidth="xl" size="xl" padding="lg"><AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostWhatIfSoftwareCouldBuildItselfSLPostPageView;
